if (!customElements.get('product-extended-price')) {
  /**
   *  @class
   *  @function ProductExtendedPrice
   */
  class ProductExtendedPrice extends HTMLElement {
    constructor() {
      super();
      this.section = this.dataset.section;
      this.unitPrice = Number(this.dataset.unitPrice) || 0;
      this.valueElement = this.querySelector('.product-extended-price__value');
    }

    connectedCallback() {
      this.onQuantityChange = this.onQuantityChange.bind(this);
      this.onVariantChange = this.onVariantChange.bind(this);

      document.addEventListener('input', this.onQuantityChange);
      document.addEventListener('change', this.onQuantityChange);
      document.addEventListener('product:variant-change', this.onVariantChange);
    }

    disconnectedCallback() {
      document.removeEventListener('input', this.onQuantityChange);
      document.removeEventListener('change', this.onQuantityChange);
      document.removeEventListener('product:variant-change', this.onVariantChange);
    }

    onQuantityChange(event) {
      if (event.target.id !== `Quantity-${this.section}`) return;
      this.render();
    }

    onVariantChange(event) {
      if (event.detail.sectionId !== this.section) return;
      this.unitPrice = event.detail.variant ? Number(event.detail.variant.price) || 0 : 0;
      this.render();
    }

    getQuantity() {
      const input = document.getElementById(`Quantity-${this.section}`);
      const value = input ? parseInt(input.value, 10) : 1;
      return isNaN(value) || value < 1 ? 1 : value;
    }

    render() {
      if (!this.valueElement) return;
      const format = (window.theme && window.theme.settings.money_with_currency_format) || '${{amount}}';
      this.valueElement.innerHTML = formatMoney(this.unitPrice * this.getQuantity(), format);
    }
  }

  customElements.define('product-extended-price', ProductExtendedPrice);
}
